// Survey callback page translations — Batch 4 (JP).
// Shared by the 5 SurveyCallbackPages components (CallbackPageLayout + the
// 4 outcome pages). hi values intentionally mirror en: the callback pages
// have always rendered in English for Hindi users, and no Hindi copy was
// provided for Batch 4 — keeping hi === en preserves that existing behavior.

export const surveyCallbackDict = {
  en: {
    // CallbackPageLayout status card copy
    "completed.headline": "Thank you!",
    "completed.subtext": "Your response has been recorded. Your points will be credited shortly.",
    "terminated.headline": "Thanks for your time.",
    "terminated.subtext": "Unfortunately you didn't qualify for this survey.",
    "overquota.headline": "Thanks for your interest.",
    "overquota.subtext": "The quota for this survey is already full.",
    "qualityterminate.headline": "Thank you for your participation.",
    "qualityterminate.subtext": "Unfortunately your response could not be accepted for this survey.",
    "loading": "Loading…",
    "goToDashboard": "Go to Dashboard",
    // Outcome page headings
    "heading.completed": "Completed",
    "heading.terminated": "Terminated",
    "heading.overquota": "Over Quota",
    "heading.qualityterminated": "Quality Terminated",
    // Shared outcome page strings
    "errorLoad": "Could not load survey details — please refresh the page after logging in.",
    "unknownError": "unknown error",
    "table.sNo": "S No",
    "table.userName": "User Name",
    "table.surveyName": "Survey Name",
    "table.points": "Points",
    "table.dateTime": "Date & Time",
    "disclaimer": "Disclaimer:",
    "pendingSuffix": " (Pending)",
  },
  hi: {
    // hi === en (callback pages render English for Hindi users — see note above)
    "completed.headline": "Thank you!",
    "completed.subtext": "Your response has been recorded. Your points will be credited shortly.",
    "terminated.headline": "Thanks for your time.",
    "terminated.subtext": "Unfortunately you didn't qualify for this survey.",
    "overquota.headline": "Thanks for your interest.",
    "overquota.subtext": "The quota for this survey is already full.",
    "qualityterminate.headline": "Thank you for your participation.",
    "qualityterminate.subtext": "Unfortunately your response could not be accepted for this survey.",
    "loading": "Loading…",
    "goToDashboard": "Go to Dashboard",
    "heading.completed": "Completed",
    "heading.terminated": "Terminated",
    "heading.overquota": "Over Quota",
    "heading.qualityterminated": "Quality Terminated",
    "errorLoad": "Could not load survey details — please refresh the page after logging in.",
    "unknownError": "unknown error",
    "table.sNo": "S No",
    "table.userName": "User Name",
    "table.surveyName": "Survey Name",
    "table.points": "Points",
    "table.dateTime": "Date & Time",
    "disclaimer": "Disclaimer:",
    "pendingSuffix": " (Pending)",
  },
  jp: {
    "completed.headline": "ありがとうございます！",
    "completed.subtext": "回答を受け付けました。ポイントは間もなく反映されます。",
    "terminated.headline": "お時間をいただきありがとうございました。",
    "terminated.subtext": "残念ながら、このアンケートの対象ではありませんでした。",
    "overquota.headline": "ご関心をお寄せいただきありがとうございます。",
    "overquota.subtext": "このアンケートの定員に達しました。",
    "qualityterminate.headline": "ご参加ありがとうございました。",
    "qualityterminate.subtext": "残念ながら、このアンケートへの回答は受け付けられませんでした。",
    "loading": "読み込み中…",
    "goToDashboard": "ダッシュボードへ",
    "heading.completed": "完了",
    "heading.terminated": "途中終了",
    "heading.overquota": "定員超過",
    "heading.qualityterminated": "品質チェック不合格",
    "errorLoad": "アンケートの詳細を読み込めませんでした — ログイン後、ページを再読み込みしてください。",
    "unknownError": "不明なエラー",
    "table.sNo": "番号",
    "table.userName": "ユーザー名",
    "table.surveyName": "アンケート名",
    "table.points": "ポイント",
    "table.dateTime": "日時",
    "disclaimer": "免責事項:",
    "pendingSuffix": "（保留中）",
  },
};
